import React, { Component } from 'react'
import parse from 'html-react-parser'

class Projects extends Component {

  render() {
    const { project } = this.props

    return (
      <>
        <section className='projects' data-color='#FFF'>
          <div className='projects__inner'>
            { project.map((item, index) => (
              <div className='projects__item' key={index}>
                <div className='projects__image'>
                  <img src={item.image.localFile.publicURL} alt={item.title} />
                </div>
                <div className='projects__content'>
                  { item.title && <h3 className='projects__item-title'>{item.title}</h3> }
                  { item.address && <h4 className='projects__item-description'>{parse(item.address)}</h4> }
                  { item.content && <div>{parse(item.content)}</div> }
                  <ul>
                    { item.builder && 
                      <li>
                        <span>Builder</span>
                        <span>{parse(item.builder)}</span>
                      </li>
                    }
                    { item.avgSalePrice && 
                      <li>
                        <span>Avg Sale Price</span>
                        <span>{parse(item.avgSalePrice)}</span>
                      </li>
                    }
                  </ul>
                </div>
              </div>        
            ))}
          </div>
        </section>
      </>
    )
  }
}

export default Projects
